import ProfilFormController from './profil.form.controller';

export default {
    template: require('./profil.form.tpl.html'),
    controller: ProfilFormController
};
